import { resource } from "@assistant-ui/tap";
import { tapSubscribable } from "../util-hooks/tapSubscribable.js";
export const MessagePartClient = resource(({ runtime }) => {
    const state = tapSubscribable(runtime);
    return {
        state,
        methods: {
            getState: () => state,
            addToolResult: (result) => runtime.addToolResult(result),
            resumeToolCall: (payload) => runtime.resumeToolCall(payload),
            __internal_getRuntime: () => runtime,
        },
    };
});
//# sourceMappingURL=MessagePartRuntimeClient.js.map